var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBskyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46825 1.74817C5.3025 3.12992 7.27575 5.93117 8 7.43442V11.4049C8 11.3204 7.9675 11.4159 7.8975 11.6217C7.5195 12.7357 6.043 17.0834 2.66675 13.6077C0.889 11.7777 1.712 9.94767 4.948 9.39517C3.09675 9.71117 1.0155 9.18892 0.4445 7.14142C0.28 6.55242 0 2.92442 0 2.43442C0 -0.0200846 2.14475 0.751415 3.46825 1.74817ZM12.5317 1.74817C10.6975 3.12992 8.72425 5.93117 8 7.43442V11.4049C8 11.3204 8.0325 11.4159 8.1025 11.6217C8.4805 12.7357 9.957 17.0834 13.3333 13.6077C15.111 11.7777 14.288 9.94767 11.052 9.39517C12.9032 9.71117 14.9845 9.18892 15.5555 7.14142C15.72 6.55242 16 2.92442 16 2.43442C16 -0.0200846 13.8555 0.751415 12.5317 1.74817Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBskyIcon);
export default __webpack_public_path__ + "static/media/bskyIcon.c54fc426c9176689025f4124b1062d75.svg";
export { ForwardRef as ReactComponent };